import { render, staticRenderFns } from "./after_sales_reasons.vue?vue&type=template&id=13aa0999&"
import script from "./after_sales_reasons.vue?vue&type=script&lang=js&"
export * from "./after_sales_reasons.vue?vue&type=script&lang=js&"
import style0 from "./after_sales_reasons.vue?vue&type=style&index=0&id=13aa0999&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports